import axios from 'axios';
import { ApiError } from 'utils/http';
import camelcaseKeys from 'camelcase-keys';

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
});

http.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob') {
      return response;
    }

    if (response.data) {
      response.data = camelcaseKeys(response.data, { deep: true });
    }

    return response;
  },
  (error) => {
    // @TODO use axios-retry for slow network

    if (error.response?.data) {
      const responseData = camelcaseKeys(error.response.data, { deep: true });

      return Promise.reject(new ApiError(responseData));
    }

    return Promise.reject(error);
  }
);
